export const LENDER_SETTINGS_FORM_PREFIX = 'lenderSettingsForm';

export const LENDER_SETTINGS_FIELDS_NAMES = {
  TAX_RATE: `${LENDER_SETTINGS_FORM_PREFIX}.taxRate`,
};
